// extracted by mini-css-extract-plugin
export default {"publiclayoutContainer":"layoutstyle_publiclayoutContainer__BipxP","contentBox":"layoutstyle_contentBox__dt0lh"};